import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import * as React from 'react';
import { ReactElement } from 'react';
import ReactToPrint from 'react-to-print';

import Header from '@/modules/workingDay/components/Details/Header';
import TeamHeader from '@/modules/workingDay/components/Details/TeamList/TeamHeader';
import { IWorkingDay } from '@/modules/workingDay/types';
import { Button } from '@/shared/components/atoms';
import DemoCTA from '@/shared/components/atoms/Demo/Modals/DemoCTA';
import { BaseIcon } from '@/shared/components/atoms/IconButton/BaseIcon';
import { useStore } from '@/shared/hooks/context/createGenericContext';
import { useModal } from '@/shared/hooks/context/modalContext/useModal';

import PrintIcon from '~/images/shared/print.svg';

interface IProps {
  instance: IWorkingDay.IJobInstance | undefined;
  suppliers: IWorkingDay.IJobInstanceSupplier[];
}
export default function Exportpdf({
  instance,
  suppliers,
}: IProps): ReactElement {
  const { locale } = useRouter();
  const { t } = useTranslation('common');
  const jobOrderRef = React.useRef(null);
  const { openModal } = useModal();
  const [isDemoFarm] = useStore((store) => store?.isDemoFarm);

  return (
    <section>
      <ReactToPrint
        removeAfterPrint
        fonts={[{ family: 'Cairo', source: '' }]}
        content={() => jobOrderRef.current}
        documentTitle={`Aydi_${isDemoFarm && 'Demo_'}Job_Instance_${
          instance?.id
        }`}
        trigger={() => (
          <Button
            color='primary'
            variant='filled'
            className=''
            onClick={() => isDemoFarm && openModal(<DemoCTA />)}
            disabled={isDemoFarm ? false : !!instance?.id}
          >
            <div className='flex items-center justify-center gap-2'>
              <BaseIcon size='md'>
                <PrintIcon />
              </BaseIcon>
              {t('print')}
            </div>
          </Button>
        )}
      />

      {/* printed qr codes */}
      <div className='hidden'>
        <div
          ref={jobOrderRef}
          className='block'
          dir={locale === 'ar' ? 'rtl' : 'ltr'}
        >
          <div className='m-16 break-inside-avoid-page text-center'>
            {/* header */}
            <Header
              instance={instance}
              showExportPdf={false}
              suppliers={suppliers}
            />
            {suppliers?.map((team) => (
              <TeamHeader
                key={team.supplierId}
                team={team}
                productivityMeasurementUnit={
                  instance?.productivityMeasurementUnit || ''
                }
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
